angular
  .module('ui-ng-session-timer')
  .factory('extendSessionCommand', function extendSessionCommandDefinition($q, $http, defineCommand) {
    return defineCommand('extendSessionCommand', function extendSessionCommand(deferred) {
      $http
        .post('core/login/extendsession/')
        .then(function (res) {
          deferred.resolve(res);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-session-timer/src/commands/extend_session_command.es.js